import { render, staticRenderFns } from "./Unsubscribe.vue?vue&type=template&id=0f5ccfb5&scoped=true&lang=pug"
import script from "./Unsubscribe.vue?vue&type=script&lang=ts"
export * from "./Unsubscribe.vue?vue&type=script&lang=ts"
import style0 from "./Unsubscribe.vue?vue&type=style&index=0&id=0f5ccfb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ccfb5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LsAlert: require('/workspace/portal/hosting/components/_base/Alert/Alert.vue').default,LsButton: require('/workspace/portal/hosting/components/_base/Button/Button.vue').default})
